import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["disabled"];
import { memoizeDeep, safeMerge } from "../common/utilities";
const setRoot = memoizeDeep(function (_ref) {
  let {
    svgicon,
    disabled,
    iconTheme,
    color
  } = _ref;
  let cssRoot = {};

  const _svgicon$root = svgicon.root,
        {
    disabled: disabledRoot
  } = _svgicon$root,
        commonRoot = _objectWithoutProperties(_svgicon$root, _excluded);

  cssRoot = commonRoot;

  if (disabled) {
    cssRoot = safeMerge(cssRoot, disabledRoot);
  }

  cssRoot = safeMerge(cssRoot, svgicon.theme.common);
  cssRoot = safeMerge(cssRoot, svgicon.theme[iconTheme]);

  if (color) {
    cssRoot = safeMerge(cssRoot, {
      fill: color
    });
  }

  return cssRoot;
});
export default function (_ref2) {
  var _internalTheme$compon;

  let {
    internalTheme,
    iconTheme,
    disabled,
    color,
    size,
    width,
    height
  } = _ref2;
  let cssRoot = {};
  const cssSvg = {};
  const svgicon = internalTheme === null || internalTheme === void 0 ? void 0 : (_internalTheme$compon = internalTheme.components) === null || _internalTheme$compon === void 0 ? void 0 : _internalTheme$compon.svgicon;

  if (svgicon) {
    cssRoot = setRoot({
      svgicon,
      disabled,
      iconTheme,
      color
    });

    if (size && typeof size === "string") {
      cssSvg.width = width || svgicon.svg.defaultSizes[size];
      cssSvg.height = height || svgicon.svg.defaultSizes[size];
    }
  }

  return {
    cssRoot,
    cssSvg
  };
}